import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../../properties/Properties';
import { isPresent } from '../../properties/funcs';

const DBM = 'dBm';

const useStyles = makeStyles((theme) => ({
    icon: {
        fontSize: 16,
        paddingRight: theme.spacing(2.5),
    },
    empty: {},
    wifiGray: {
        '& span': {
            color: theme.palette.status.gray,
        },
    },
    wifiSuccess: {
        '& span': {
            color: theme.palette.status.green,
        },
    },
    wifiFail: {
        '& span': {
            color: theme.palette.status.red,
        },
    },
}));

const STATUS_TABLE = {
    Running: 'Running',
    Disabled: 'Disabled',
    Deleted: 'Deleted',
    Restarting: 'Restarted',
    Unclaimed: 'Deleted', // O stands for Orphaned which has the exact same behavior as deleted.
    Updating: 'Update',
    Offline: 'Down',
    F: 'Updating',
};

const wirelessState = (data) => {
    if (!data.isWirelessEnabled && !data.isDynamicWirelessEnabled) {
        return {
            icon: 'signal_wifi_4_bar',
            wirelessClass: 'wifiGray',
            tooltip: i18n._(t`Wi-Fi Network Disabled`),
        };
    }
    if (data.isDynamicWirelessEnabled) {
        return {
            icon: 'network_check',
            wirelessClass: 'empty',
            tooltip: i18n._(t`nPoint in Multiple SSID Testing Mode`),
        };
    }

    if (data.wifiConnected) {
        return {
            icon: 'signal_wifi_4_bar',
            wirelessClass: 'wifiSuccess',
            tooltip: i18n._(t`Wi-Fi Network Connected`),
        };
    }

    if (data.status === STATUS_TABLE.Running) {
        return {
            icon: 'signal_wifi_4_bar',
            wirelessClass: 'wifiFail',
            tooltip: isPresent(data.wifiErrors) ? data.wifiErrors : i18n._(t`Wi-Fi Network Not Connected`),
        };
    }
    return {
        icon: 'signal_wifi_4_bar',
        wirelessClass: 'wifiGray',
        tooltip: i18n._(t`nPoint not Running`),
    };
};

const WirelessNetwork = ({ data }) => {
    const classes = useStyles();

    const { wirelessClass, tooltip, icon } = wirelessState(data);
    const ssid = data.wifiSsid;
    const wifiSignalLevel = data.wifiSignalLevelDbm;
    const wifiSignalLevelFmt = wifiSignalLevel ? ` (${wifiSignalLevel} ${DBM}) ` : '';

    return (
        <div className={classes[wirelessClass]}>
            <Tooltip title={tooltip} placement="left-start">
                <Icon className={classes.icon}>{icon}</Icon>
            </Tooltip>
            {`${ssid}${wifiSignalLevelFmt}`}
        </div>
    );
};

export const agentWirelessNetworkProperty = {
    type: ROW_TYPES.FUNCTION,
    hasValue: (data) => isPresent(data?.wifiSsid),
    title: i18n._(t`Wi-Fi Network`),
    mapper: (data) => {
        return <WirelessNetwork data={data} />;
    },
};
